// YANRE FITNESS EUROPE — Landing Page Engine configuration (single source of truth).

// Verified official YANRE FITNESS EUROPE WhatsApp (configured 2026-07).
export const WHATSAPP_NUMBER = "351910619033"; // +351 910 619 033

// Institutional YANRE FITNESS EUROPE WEBSITE — NOT yet production-ready.
// Leave empty until a verified production URL is supplied; while empty,
// all "Visit Website" actions and the header logo link stay inert
// (no preview/dev URL is ever exposed to visitors).
export const INSTITUTIONAL_WEBSITE_URL = "";

// Pre-filled WhatsApp messages, keyed by landing page → language.
// Region/campaign variants can be layered here later without touching
// the component.
export const WHATSAPP_MESSAGES = {
  "open-your-gym": {
    en: "Hello YANRE FITNESS EUROPE. I'm interested in a fitness project and would like to speak with a specialist.",
    pt: "Olá YANRE FITNESS EUROPE. Estou interessado num projeto de fitness e gostaria de falar com um especialista.",
  },
  "personal-trainer-studio": {
    en: "Hello YANRE FITNESS EUROPE. I'm planning my own personal training studio and would like to speak with a specialist.",
    pt: "Olá YANRE FITNESS EUROPE. Estou a planear o meu estúdio de treino e gostaria de falar com um especialista.",
    br: "Olá YANRE FITNESS EUROPE. Estou planejando meu estúdio de treinamento e gostaria de falar com um especialista.",
    es: "Hola YANRE FITNESS EUROPE. Estoy planeando mi propio estudio de entrenamiento y me gustaría hablar con un especialista.",
    fr: "Bonjour YANRE FITNESS EUROPE. Je prépare l'ouverture de mon studio de coaching et j'aimerais échanger avec un spécialiste.",
    de: "Hallo YANRE FITNESS EUROPE. Ich plane mein eigenes Personal Training Studio und würde gerne mit einem Spezialisten sprechen.",
    it: "Buongiorno YANRE FITNESS EUROPE. Sto pianificando il mio studio personal training e vorrei parlare con uno specialista.",
    ar: "مرحباً YANRE FITNESS EUROPE. أخطط لافتتاح استوديو التدريب الشخصي الخاص بي وأود التحدث مع أخصائي.",
  },
};

export const whatsappMessage = ({ page = "open-your-gym", lang = "en" } = {}) =>
  WHATSAPP_MESSAGES[page]?.[lang] ||
  WHATSAPP_MESSAGES[page]?.en ||
  WHATSAPP_MESSAGES["open-your-gym"].en;
